import React, { Component } from 'react';
import { getToken } from '../../../../../config/index';
import Axios from 'axios';
import toastr from 'toastr';
import Spinner from 'react-bootstrap/Spinner';

export class Question7Startup extends Component {
  state = {
    description: '',
    edit: false,
    ok: true,
    nextloading: false,
    loading: true,
    chart: '',
    error: '',
  };

  handleBack = () => {
    this.props.next(-1);
  };

  handleChange = (e) => {
    if (e.target.value.split(' ').length < 100) {
      this.setState({
        description: e.target.value,
        edit: true,
      });
    }
  };

  handleSave = () => {
    if (this.state.edit) {
      this.setState({
        nextloading: true,
      });
      const data = {
        id: this.props.id,
        description: this.state.description,
      };
      Axios.post('/api/app/quick_look/modulo1/question7Startup', data, {
        headers: { Authorization: 'Bearer ' + getToken() },
      }).then((response) => {
        if (response.data.ok) {
          toastr.remove();
          toastr.success('Saved!');
          this.props.next(1);
        } else {
          toastr.remove();
          toastr.warning(response.data.error);
        }
        this.setState({
          nextloading: false,
        });
      });
    } else {
      this.props.next(1);
    }
  };

  componentDidMount() {
    this.props.changeVideo('ahiz0hvj0u');
    Axios.get(
      '/api/app/quick_look/modulo1/question7Startup?id=' + this.props.id,
      {
        headers: { Authorization: 'Bearer ' + getToken() },
      },
    ).then((response) => {
      if (response.data.ok) {
        if (response.data.description) {
          this.setState({
            loading: false,
            description: response.data.description,
          });
        } else {
          this.setState({
            loading: false,
            description: '',
          });
        }
      } else {
        this.setState({
          ok: false,
          error: response.data.error,
        });
      }
    });
  }

  render() {
    return (
      <>
        {this.state.ok ? (
          this.state.loading ? (
            <div className="col-2 text-center mx-auto">
              <Spinner animation="border" variant="secondary" />
            </div>
          ) : (
            <>
              <p className="question-title">
                <b>Question 1.7</b>
              </p>
              <p className="mb-4">
                From your list of problems, try to determine the root cause of
                those problems.
                <br />
                <br />
                Describe what you feel is the root cause of the issue. <br />
                Start with a problem and ask WHY four times: “WHY does this
                happen” and “WHY does that happen” and “WHY does that happen”
                and “WHY does that happen” - when you can’t go any deeper,
                you’ve probably found your root cause.
              </p>
              <div className="row mx-auto" style={{ width: '95%' }}>
                <textarea
                  onChange={this.handleChange}
                  value={this.state.description}
                  className="description"
                  name="description"
                ></textarea>
                {this.state.description.split(' ').length < 99 ? (
                  <small style={{ top: '80%', left: '3%' }}>
                    100 words max
                  </small>
                ) : (
                  <small style={{ top: '80%', left: '3%', color: 'red' }}>
                    100 words max
                  </small>
                )}
              </div>
              <hr />
              <div
                style={{
                  width: '100%',
                  justifyContent: 'space-between',
                  display: 'flex',
                }}
              >
                <button
                  className="btn my-4 p-3"
                  style={{
                    color: 'white',
                    backgroundColor: '#cea977',
                    borderRadius: '10px',
                  }}
                  onClick={this.handleBack}
                >
                  <i className="fas fa-arrow-left"></i> Back
                </button>
                <button
                  className="btn my-4 p-3"
                  style={{
                    color: 'white',
                    backgroundColor: '#cea977',
                    borderRadius: '10px',
                  }}
                  onClick={this.handleSave}
                >
                  {this.state.nextloading ? (
                    <>
                      <Spinner animation="border" variant="light" size="sm" />{' '}
                      Saving...
                    </>
                  ) : (
                    <>
                      {this.state.edit ? 'Save & Next' : 'Next'}{' '}
                      <i className="fas fa-arrow-right"></i>{' '}
                    </>
                  )}
                </button>
              </div>
            </>
          )
        ) : (
          <>
            {this.state.error}
            <div
              style={{
                width: '100%',
                justifyContent: 'space-between',
                display: 'flex',
              }}
            >
              <button
                className="btn my-4 p-3"
                style={{
                  color: 'white',
                  backgroundColor: '#cea977',
                  borderRadius: '10px',
                }}
                onClick={this.handleBack}
              >
                <i className="fas fa-arrow-left"></i> Back
              </button>
            </div>
          </>
        )}
      </>
    );
  }
}

export default Question7Startup;
